import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpHeaderResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AutenticacionService } from './autenticacion.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {



  cReq: number = 0;
  cRes: number = 0;



  constructor(  private _router: Router, 
                private _autenticacionService: AutenticacionService,
                private toastr: ToastrService) { }



  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    this.cReq++;
    let jwt = localStorage.getItem('ACCESS_TOKEN');
    if (!!jwt) {
      let headers = new HttpHeaders({
        //'Content-Type': 'application/json;charset=UTF-8',
        //'Accept': 'application/json',
        'Access-Control-Allow-Methods': '*',
        'Authorization': `Bearer ${jwt}`
      });
      request = request.clone({
        headers: headers
      });
    }


    return next.handle(request)
      .pipe(
        map(event => {
          //muestra el loading para todos los servicios menos para estadisticas
          //this._util.displaySpinner = true;

          if (event instanceof HttpResponse) {
            this.cRes++;
            if (this.cReq <= this.cRes) {
              //this._util.displaySpinner = false;
              this.cReq = 0;
              this.cRes = 0;
            }
            //ejemplo de como coger token del response
            if (event.headers.get('Authorization')) {
              if (event.headers.get('Authorization') == 'expired') {
                //this._mess.clear('t_session');
                //this._mess.add({ key: 't_session', sticky: true, severity: 'warn', summary: 'Su sesión ha expirado', detail: 'CLIC en SALIR y vuelva a iniciar sesión', closable: false });
              } else if (event.headers.get('Authorization') == 'denied') {
                //this._mess.clear('t_session');
                //this._mess.add({ key: 't_session', sticky: true, severity: 'error', summary: 'Acceso denegado', detail: 'CLIC en SALIR y vuelva a iniciar sesión', closable: false });
              } else {
                sessionStorage.setItem('Authorization', event.headers.get('Authorization'));
              }
            }
            return event;
          }
        }),
        catchError((error: any) => {          

          if (request.url.indexOf("login")<0 && error.status == 401) {
            this._autenticacionService.borrarSesion();
            this._router.navigate([""]);
            this.toastr.info('Su sesión ha expirado, haga CLIC en SALIR y vuelva a iniciar sesión');
          } 
          return throwError(error);
        })
      )


  }



}
